import { defineStore } from 'pinia';
import { authApi } from '@api/auth.api';

const TOKEN_KEY = 'cuxa_token';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem(TOKEN_KEY) || '',
    authRequired: null as boolean | null,
  }),

  getters: {
    isAuthenticated(): boolean {
      return !!this.token;
    },
  },

  actions: {
    setToken(t: string) {
      this.token = t;
      if (t) localStorage.setItem(TOKEN_KEY, t);
      else localStorage.removeItem(TOKEN_KEY);
    },

    logout() {
      this.setToken('');
    },

    async fetchStatus(): Promise<boolean> {
      if (this.authRequired !== null) return this.authRequired;
      try {
        const status = await authApi.getStatus();
        this.authRequired = status.authRequired;
        return status.authRequired;
      } catch {
        this.authRequired = true;
        return true;
      }
    },

    async login(password: string): Promise<{ ok: boolean; error?: string }> {
      try {
        const res = await authApi.login(password);
        if (res.authRequired === false) {
          this.authRequired = false;
          return { ok: true };
        }
        if (res.token) {
          this.setToken(res.token);
          return { ok: true };
        }
        return { ok: false, error: 'Réponse invalide' };
      } catch (err: unknown) {
        const msg = (err as { response?: { data?: { error?: string } } })?.response?.data?.error;
        return { ok: false, error: msg || 'Erreur de connexion' };
      }
    },
  },
});
